/**
 * E-Commerce Service API
 * This is the ecommerce-service API generated by springdocs - a library for OpenAPI 3 with spring boot.
 *
 * The version of the OpenAPI document: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ErrorResponse } from './errorResponse';


export interface CustomerDto { 
    id?: number;
    option?: string;
    firstNames?: string;
    preferredName?: string;
    lastName?: string;
    guest?: boolean;
    email?: string;
    mobile?: string;
    password?: string;
    passwordConfirm?: string;
    company?: string;
    billingAddressLine1?: string;
    billingAddressLine2?: string;
    billingAddressCity?: string;
    billingAddressProvinceId?: string;
    billingAddressPostalCode?: string;
    billingAndDeliveryAddressSame?: boolean;
    deliveryFirstNames?: string;
    deliveryLastName?: string;
    deliveryCompany?: string;
    deliveryAddressLine1?: string;
    deliveryAddressLine2?: string;
    deliveryAddressCity?: string;
    deliveryAddressProvinceId?: string;
    deliveryAddressPostalCode?: string;
    error?: ErrorResponse;
}

